import { render, staticRenderFns } from "./TypeMontev2.vue?vue&type=template&id=3aaac290&"
import script from "./TypeMontev2.vue?vue&type=script&lang=js&"
export * from "./TypeMontev2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports